import { useQuery } from '@tanstack/react-query';
import { supabase } from '../services/supabase';

export type GrowthMonitoredPage = {
  id: string;
  scope: string;
  peer_name: string | null;
  label: string;
  url: string;
  enabled: boolean;
};

export type GrowthPageDiff = {
  id: string;
  monitored_page_id: string;
  diff_category: string;
  diff_summary: string;
  evidence: Record<string, unknown>;
  created_at: string;
};

async function fetchMonitoredPages(): Promise<GrowthMonitoredPage[]> {
  const { data, error } = await supabase
    .from('growth_monitored_pages')
    .select('id, scope, peer_name, label, url, enabled')
    .order('scope')
    .order('label');
  if (error) throw error;
  return (data ?? []) as GrowthMonitoredPage[];
}

async function fetchDiffs(limit = 50): Promise<GrowthPageDiff[]> {
  const { data, error } = await supabase
    .from('growth_page_diffs')
    .select('id, monitored_page_id, diff_category, diff_summary, evidence, created_at')
    .order('created_at', { ascending: false })
    .limit(limit);
  if (error) throw error;
  return (data ?? []) as GrowthPageDiff[];
}

export function useGrowthMonitoredPages() {
  return useQuery({
    queryKey: ['growth', 'monitored-pages'],
    queryFn: fetchMonitoredPages,
  });
}

export function useGrowthDiffs() {
  return useQuery({
    queryKey: ['growth', 'diffs'],
    queryFn: () => fetchDiffs(50),
  });
}
